import axios from "axios";

const endpoint_url = "/campaignV2/customer/luckyDraw/traditionalRaffleList";

const getTraditionalRaffleList = (parameters) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, { params: parameters })
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getTraditionalRaffleList;
